__webpack_require__.p = "/lol-worlds-calculator/";